import { render } from "./BackToTopDemo.vue?vue&type=template&id=fafdfd12&scoped=true"
import script from "./BackToTopDemo.vue?vue&type=script&lang=ts"
export * from "./BackToTopDemo.vue?vue&type=script&lang=ts"

import "./BackToTopDemo.vue?vue&type=style&index=0&id=fafdfd12&lang=scss&scoped=true"
script.render = render
script.__scopeId = "data-v-fafdfd12"

export default script